
export class Environment {

  public static readonly version = '1.0.0';
  public static readonly environment = 'qa';
  public static readonly production = false;
  public static readonly gatewayUrl = 'https://see-link-cloud-gateway-qa.apps.ire.sealedair.io';
  public static readonly socketIoServerUrl = 'https://see-link-dataflow-websocket-qa.apps.ire.sealedair.io';
  public static readonly socketIoServerSecure = false;
  public static readonly googleMapsApiKey = 'AIzaSyAcxQfoPk_p4ekaEayrBwUegl20OlDSVPo';
  public static readonly fsId = '0';
  public static readonly gaTagId = 'G-KEDZEX15P4';
}
